interface ListState<T> {
  loading: boolean;
  loadingState: boolean;
  data?: T[];
  items?: T[];
  page?: number;
  totalPages?: number;
  totalItems?: number;
}

interface ObjectState<T> {
  loading: boolean;
  loadingState: boolean;
  data: T;
}

interface LocationPoint {
  id: number;
  name: string;
}

interface LocationItem {
  id?: number;
  name?: string;
  points?: LocationPoint[];
  image?: string;
  minPrice?: string;
  status?: boolean;
}

interface RootState {
  user: ObjectState<any>;
  adminBanners: ListState<any>;
  storeBanners: ListState<any>;
  singleBanner: ObjectState<any>;

  pushNotification: ListState<any>;
  dashboard: ObjectState<any>;
  topPerformers: ObjectState<any>;
  notifications: ListState<any>;
  allNotifications: ListState<any>;
  location: ListState<LocationItem>;
  users: ListState<any>;
  inidividualUser: ObjectState<any>;

  supportMessages: ListState<any>;

  config: ObjectState<any>;
  zones: ListState<any>;
  singleZone: ObjectState<any>;
  modules: ListState<any>;
  categories: ListState<any>;
  subcategories: ListState<any>;
  brands: ListState<any>;
  shapes: ListState<any>;
  attributes: ListState<any>;
  singleAttribute: ObjectState<any>;
  colors: ListState<any>;
  subscriptions: ListState<any>;
  adminCoupons: ListState<any>;
  storeCoupons: ListState<any>;
  cancellations: ListState<any>;
  //general settings
  termsAndConditions: ObjectState<any>;
  privacyPolicy: ObjectState<any>;
  cancellationPolicy: ObjectState<any>;
  aboutUs: ObjectState<any>;
  maintainanceMode: ObjectState<any>;
  commissionSetting: ObjectState<any>;
  rescheduleSetting: ObjectState<any>;
  cancellationSetting: ObjectState<any>;
  appSettings: ObjectState<any>;
  aboutUsSeo: ObjectState<any>;
  privacyPolicySeo: ObjectState<any>;
  bookingPolicySeo: ObjectState<any>;
  cancellationPolicySeo: ObjectState<any>;
  termsAndConditionsSeo: ObjectState<any>;
  //bussiness setting
  //general
  suppportInfo: ObjectState<any>;
  modulesPercentage: ObjectState<any>;
  favicon: ObjectState<any>;
  headerLogo: ObjectState<any>;
  footerLogo: ObjectState<any>;
  logoSetup: ListState<any>;
  //payment
  orderSettings: ListState<any>;

  stores: ListState<any>;
  deliveries: ListState<any>;
  units: ListState<any>;
  storeTypes: ListState<any>;
  products: ListState<any>;

  editStore: boolean;
  addons: ObjectState<any>;
  lensaddons: ListState<any>;
  productData: ObjectState<any>;
  singleStore: ObjectState<any>;
  provinces: ListState<any>;
  districts: ListState<any>;
  municipals: ListState<any>;
  featuredStores: ListState<any>;
  popularStores: ListState<any>;
  recommendedStores: ListState<any>;
  admins: ListState<any>;
  roles: ListState<any>;
  customers: ListState<any>;
  customerAnalytics: ObjectState<any>;
  conversations: ListState<any>;
  messages: ListState<any>;
  onboarding: ListState<any>;
  splashScreen: ListState<any>;
  call: {
    active: boolean;
    incoming: boolean;
    conversationId: number | null;
    callerName: string | null;
    type: "video" | "audio" | null;
    status: "idle" | "calling" | "connected" | "ended" | "rejected";
  };
  categorySections: ListState<any>;
  deals: ListState<any>;
  singleDeal: ObjectState<any>;
  redeemCodes: ListState<any>;
  auditLogs: ListState<any>;
  storeEmployees: ListState<any>;
}

const initialState: RootState = {
  user: {
    loading: true,
    loadingState: true,
    data: {},
  },

  adminBanners: {
    loading: true,
    loadingState: true,
    data: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },
  storeBanners: {
    loading: true,
    loadingState: true,
    data: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },
  singleBanner: {
    loading: true,
    loadingState: true,
    data: {},
  },

  termsAndConditions: {
    loading: true,
    loadingState: true,
    data: {},
  },
  privacyPolicy: {
    loading: true,
    loadingState: true,
    data: {},
  },
  aboutUs: {
    loading: true,
    loadingState: true,
    data: {},
  },
  cancellationPolicy: {
    loading: true,
    loadingState: true,
    data: {},
  },

  dashboard: {
    data: {},
    loading: true,
    loadingState: true,
  },
  topPerformers: {
    data: {},
    loading: true,
    loadingState: true,
  },

  pushNotification: {
    loading: true,
    loadingState: true,
    items: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },
  cancellations: {
    loading: true,
    loadingState: true,
    items: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },
  notifications: {
    loading: true,
    loadingState: true,
    items: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },

  location: {
    loading: true,
    loadingState: true,
    items: [],
    totalItems: 0,
    totalPages: 0,
    page: 0,
  },
  users: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  inidividualUser: {
    loading: true,
    loadingState: true,
    data: {},
  },

  supportMessages: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },

  config: {
    data: {},
    loading: true,
    loadingState: true,
  },
  zones: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  allNotifications: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  categories: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  brands: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  shapes: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  attributes: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  units: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  storeTypes: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  singleAttribute: {
    loading: true,
    loadingState: true,
    data: {},
  },
  subscriptions: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  adminCoupons: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  storeCoupons: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  singleZone: {
    loading: true,
    loadingState: true,
    data: [],
  },
  modules: {
    loading: true,
    loadingState: true,
    data: [],
  },
  colors: {
    loading: true,
    loadingState: true,
    data: [],
  },

  //general settings
  aboutUsSeo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  privacyPolicySeo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  bookingPolicySeo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  cancellationPolicySeo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  termsAndConditionsSeo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  maintainanceMode: {
    loading: true,
    loadingState: true,
    data: {},
  },
  commissionSetting: {
    loading: true,
    loadingState: true,
    data: {},
  },
  rescheduleSetting: {
    loading: true,
    loadingState: true,
    data: {},
  },
  cancellationSetting: {
    loading: true,
    loadingState: true,
    data: {},
  },
  appSettings: {
    loading: true,
    loadingState: true,
    data: {},
  },
  suppportInfo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  modulesPercentage: {
    loading: true,
    loadingState: true,
    data: {},
  },

  favicon: {
    loading: true,
    loadingState: true,
    data: {},
  },
  headerLogo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  footerLogo: {
    loading: true,
    loadingState: true,
    data: {},
  },
  logoSetup: { loading: true, loadingState: true, data: [] },
  orderSettings: { loading: true, loadingState: true, data: [] },
  stores: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  deliveries: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  subcategories: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  products: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  addons: {
    loading: true,
    loadingState: true,
    data: {},
  },
  editStore: false,
  lensaddons: {
    loading: true,
    loadingState: true,
    data: [],
  },
  productData: {
    loading: true,
    loadingState: true,
    data: {},
  },
  singleStore: {
    loading: true,
    loadingState: true,
    data: {},
  },
  provinces: {
    loading: true,
    loadingState: true,
    data: [],
  },
  districts: {
    loading: true,
    loadingState: true,
    data: [],
  },
  municipals: {
    loading: true,
    loadingState: true,
    data: [],
  },
  featuredStores: {
    loading: true,
    loadingState: true,
    data: [],
  },
  popularStores: {
    loading: true,
    loadingState: true,
    data: [],
  },
  recommendedStores: {
    loading: true,
    loadingState: true,
    data: [],
  },
  admins: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  roles: {
    loading: true,
    loadingState: true,
    items: [],
  },
  customers: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  customerAnalytics: {
    loading: true,
    loadingState: true,
    data: {},
  },
  conversations: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  messages: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  onboarding: {
    loading: true,
    loadingState: true,
    data: [],
  },
  splashScreen: {
    loading: true,
    loadingState: true,
    data: [],
  },
  call: {
    active: false,
    incoming: false,
    conversationId: null,
    callerName: null,
    type: null,
    status: "idle",
  },
  categorySections: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  deals: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  singleDeal: {
    loading: true,
    loadingState: true,
    data: {},
  },
  redeemCodes: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  auditLogs: {
    loading: true,
    loadingState: true,
    items: [],
    page: 0,
    totalPages: 0,
    totalItems: 0,
  },
  storeEmployees: {
    loading: true,
    loadingState: true,
    data: [],
  },
};

export default initialState;
